
import { environment } from '../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { LocaleService, TranslationService, Language } from 'angular-l10n';
import { ApiService } from '../../services/api.service';
import { Onboarding, Status, PuntoDiContatto } from '../../models/onboarding';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'alg-wip',
  templateUrl: './alg-wip.component.html',
  styleUrls: ['./alg-wip.component.scss']
})
export class AlgWipComponent implements OnInit {
  title = 'Luce&Gas Coop ';
  public day:string;
  public from:string;
  public to:string;
  public noData:boolean;
  
  ngOnInit(): void {



    this.api.checkWipStatus().toPromise().then((data:any) => {
      console.log('data');
      if(!data || !data.from || !data.to) return this.noData = true
      this.day = `${data.from.split("T")[0].split('-')[2]}/${data.from.split("T")[0].split('-')[1]}/${data.from.split("T")[0].split('-')[0]}`;
      this.from = `${Number(data.from.split("T")[1].split(':')[0]) + 1}:${data.from.split("T")[1].split(':')[1]}`
      this.to = `${Number(data.to.split("T")[1].split(':')[0]) + 1}:${data.to.split("T")[1].split(':')[1]}`
      
    }).catch(err =>{
      console.log(err)
    });
  }

  constructor(
    public locale: LocaleService,
    public translation: TranslationService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {

}

    goToClic(){
        return window.location.href='https://www.accendilucegas.it/magazine/';
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/alg-wip/alg-wip.component.ts